import { Map } from 'immutable';
import HFUsage from './model';

import {
  FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS,
} from './actions';

export default function onlineHomeworkHFUsageReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS:
      return state.set(`${action.groupId}`, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(payload = []) {
  return payload.reduce((map, student) =>
    map.set(`${student.studentId}`, HFUsage.create(student))
      , new Map());
}




// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/reducer.js